import { lazy } from 'react'

export const ACColor = lazy(() => import('./Color'))
export const ACBorder = lazy(() => import('./Border'))
export const ACCheckbox = lazy(() => import('./Checkbox'))
export const ACFont = lazy(() => import('./Font'))
export const ACNumber = lazy(() => import('./Number'))
export const ACSelect = lazy(() => import('./Select'))
export const ACText = lazy(() => import('./Text'))
